var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWebsiteCreate = function SvgWebsiteCreate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3188 19.1842V26.2895H15.4097V19.1842H18.3188Z",
    fill: "#7EAAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86429 25.579C8.86429 24.7942 9.51551 24.158 10.3188 24.158H23.4097C24.2131 24.158 24.8643 24.7942 24.8643 25.579C24.8643 26.3638 24.2131 27.0001 23.4097 27.0001H10.3188C9.51551 27.0001 8.86429 26.3638 8.86429 25.579Z",
    fill: "#7EAAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.864258 3.55263C0.864258 1.59057 2.49231 0 4.50062 0H29.2279C31.2362 0 32.8643 1.59057 32.8643 3.55263V17.7632C32.8643 19.7252 31.2362 21.3158 29.2279 21.3158H4.50062C2.49231 21.3158 0.864258 19.7252 0.864258 17.7632V3.55263ZM4.50062 2.84211C4.09896 2.84211 3.77335 3.16022 3.77335 3.55263V17.7632C3.77335 18.1556 4.09896 18.4737 4.50062 18.4737H29.2279C29.6296 18.4737 29.9552 18.1556 29.9552 17.7632V3.55263C29.9552 3.16022 29.6296 2.84211 29.2279 2.84211H4.50062Z",
    fill: "#7EAAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8642 6.349V15.1504",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5006 10.7496L21.2279 10.7496",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebsiteCreate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/website-create.20afe806.svg";
export { ForwardRef as ReactComponent };